
export function clearLocalSSOStorage(): void {
  localStorage.clear();
  sessionStorage.clear();
}
